import { render, staticRenderFns } from "./redirectTable.vue?vue&type=template&id=2ada7294&scoped=true&"
import script from "./redirectTable.vue?vue&type=script&lang=js&"
export * from "./redirectTable.vue?vue&type=script&lang=js&"
import style0 from "./redirectTable.vue?vue&type=style&index=0&id=2ada7294&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ada7294",
  null
  
)

export default component.exports